import { createContext } from 'react'

type HEREMapContext = {
  map?: H.Map
}

export const MapContext = createContext<HEREMapContext>({})
